import { Component, OnInit } from '@angular/core';
import {faCheckCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-business-development-advisory',
  templateUrl: './business-development-advisory.component.html',
  styleUrls: ['./business-development-advisory.component.css']
})
export class BusinessDevelopmentAdvisoryComponent implements OnInit {

  faCheckCircle = faCheckCircle;

  constructor() { }

  ngOnInit(): void {
  }

}
